import { NumberInput } from "@msuite/ui/form";
import { useTranslation } from "@msuite/ui/localization";
import type { CalculationFormSchema } from "@msuite/utils/schemas";
import { useFormContext } from "react-hook-form";
import type { CalculationFormItemPositionFieldsSharedProps } from "./calculation-form-item-position-fields-shared";

export function CalculationFormItemPositionFieldsPiece({
	index,
	positionIndex,
	step = 0.01,
}: CalculationFormItemPositionFieldsSharedProps & { step?: number }) {
	/** Context */
	const methods = useFormContext<CalculationFormSchema>();

	/** Hooks */
	const { t } = useTranslation();

	/** Render */
	return (
		<NumberInput
			isRequired
			label={t("calculations.quantity")}
			control={methods.control}
			name={`services.${index}.positions.${positionIndex}.quantity`}
			min={0}
			step={step}
			placeholder={1}
			variant="decimal"
			errorVariant="tooltip"
		/>
	);
}
